import { Loader2 } from 'lucide-react'

type LoadingSpinnerProps = {
  /** Optional short message below the spinner */
  message?: string
  /** Size of the spinner: 'sm' | 'default' | 'lg' */
  size?: 'sm' | 'default' | 'lg'
  /** Extra class for the container */
  className?: string
}

const sizeClasses = {
  sm: 'h-5 w-5',
  default: 'h-8 w-8',
  lg: 'h-10 w-10',
}

export function LoadingSpinner({ message, size = 'default', className = '' }: LoadingSpinnerProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 p-8 ${className}`}
      role="status"
      aria-label={message ?? 'Loading'}
    >
      <Loader2
        className={`${sizeClasses[size]} animate-spin text-muted-foreground`}
        aria-hidden
      />
      {message && (
        <p className="text-sm text-muted-foreground">{message}</p>
      )}
    </div>
  )
}
